import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    capital: 'Company capital amount (€)',
    employees: 'Number of employees',
    financialData: 'Financial data',
    hasActivityOutsideEU: 'Operates outside the European Union',
    no: 'No',
    title: 'Company financial information',
    turnover: 'Annual turnover (€)',
    validate: 'Confirm my information',
    yes: 'Yes',
  },
  fr: {
    capital: 'Montant du capital social de la société (€)',
    employees: 'Nombre de salarié•e•s',
    financialData: 'Données financières',
    hasActivityOutsideEU: 'Opère en dehors de l’Union Européenne',
    no: 'Non',
    title: 'Informations financières de votre entreprise',
    turnover: 'Chiffre d’affaire annuel (€)',
    validate: 'Confirmer mes informations',
    yes: 'Oui',
  },
} as const);

export default locales;
